import { render, staticRenderFns } from "./DetailDrawer.vue?vue&type=template&id=490c5edc&scoped=true&"
import script from "./DetailDrawer.vue?vue&type=script&lang=js&"
export * from "./DetailDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DetailDrawer.vue?vue&type=style&index=0&id=490c5edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c5edc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VForm,VIcon,VImg,VRow,VSelect,VSimpleTable})
